import React from "react";
import { Star } from "lucide-react";

export default function StarRating({ value = 0, size = 16, className = "" }) {
  const full = Math.floor(value);
  const half = value - full >= 0.5;
  return (
    <div className={`flex items-center gap-0.5 ${className}`} aria-label={`${value} out of 5 stars`}>
      {[0, 1, 2, 3, 4].map((i) => {
        const filled = i < full;
        const isHalf = i === full && half;
        return (
          <span key={i} className="relative inline-block" style={{ width: size, height: size }}>
            <Star size={size} className="absolute inset-0 text-neutral-700" strokeWidth={1.5} />
            {(filled || isHalf) && (
              <span className="absolute inset-0 overflow-hidden" style={{ width: isHalf ? size / 2 : size }}>
                <Star size={size} className="text-[#e2f163] fill-[#e2f163]" strokeWidth={1.5} />
              </span>
            )}
          </span>
        );
      })}
    </div>
  );
}
